import React from "react";
import PageLayout from "../../../components/PageLayout";
import jeyedaDatasourcesHelp from "../../../content/help/jeyeda-datasources.json";
import JeyedaDatasourcesTable from "./JeyedaDatasourcesTable";
import { fetchDatasources } from "./JeyedaDatasourcesAPI";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";

export default function JeyedaDatasources({
  pageTitle = "Jeyeda Datasources",
}) {
  usePageTitle("Jeyeda Datasources - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    onPageChange,
  } = usePageState({
    fetchFn: fetchDatasources,
    filterFields: [
      (p) => p.id?.toString(),
      "label",
      "dbFlavour",
      "status",
      "jdbcUrl",
      (p) => p.owner?.username,
      (p) => p.sharedTo?.map((u) => u.username).join(" "),
    ],
  });

  return (
    <div className="jeyeda-datasources-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        logoSrc="/img/Jeyeda_logo_no_text.png"
        description="Manage and monitor Jeyeda Datasources connections."
        helpContent={jeyedaDatasourcesHelp}
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
        />

        <JeyedaDatasourcesTable
          data={filteredData}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      </PageLayout>
    </div>
  );
}
